import React from 'react';
import { SxStyle } from '../../../../../types';
import { darkenColor, fontColor } from './theme';
import Box from '@mui/material/Box';
import PreviewTopBar from '../../../preview-topbar';
import Grid2 from '@mui/material/Grid2';
import { ReactComponent as Notifications } from './previews/notifications.svg';
import { ReactComponent as Testcard } from './previews/testcard.svg';
import { ReactComponent as Leadertable } from './previews/leadertable.svg';
import { ReactComponent as Standings } from './previews/standings.svg';
import { ReactComponent as Clubselect } from './previews/clubselect.svg';
import { ReactComponent as Teamselect } from './previews/teamselect.svg';
import { ReactComponent as Bottombar } from './previews/bottombar.svg';
import { ReactComponent as Loginmodal } from './previews/loginmodal.svg';
import { ReactComponent as Matchform } from './previews/matchform.svg';
import { ReactComponent as Ratingmodal } from './previews/ratingmodal.svg';
import { ReactComponent as Game } from './previews/game.svg';
import { ReactComponent as News } from './previews/news.svg';
import { ReactComponent as Voting } from './previews/voting.svg';
import { ReactComponent as Tabs } from './previews/tabs.svg';
import { ReactComponent as Matches } from './previews/matches.svg';
import { ReactComponent as Primarybutton } from './previews/primarybutton.svg';
import { ReactComponent as Contrastbutton } from './previews/contrastbutton.svg';
import { ReactComponent as Borderbutton } from './previews/borderbutton.svg';
import { PaletteColors } from '../../../../../types/app-config';

const styles: SxStyle = {
  container: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px',
  },
  scrollContainer: {
    overflowY: 'scroll',
    paddingTop: 5,
    paddingBottom: 5,
    maxHeight: '1550px',
    // height: 'calc(100% - 64px)',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'flex-start',
    overflowX: 'hidden',

    // Reduce the space between the svgs
    '& svg': {
      marginTop: '-20px',
    },

    // Custom scrollbar styling
    scrollbarColor: '#c1c1c1 transparent',
    scrollbarWidth: '8px',
    '&::-webkit-scrollbar': {
      width: '12px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#c1c1c1',
      borderRadius: '10px',
      border: '2px solid transparent',
      backgroundClip: 'content-box',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#7d7d7d',
    },
  },
  column: {
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

interface Props {
  teamName: string;
  topBarOverride?: boolean;
  colors: PaletteColors;
  logoImageUrl?: string;
}

const Preview = ({ teamName, topBarOverride, colors, logoImageUrl }: Props) => {
  const previewContainer = {
    ...styles.scrollContainer,
    '& .id-main': {
      fill: colors.ID_MAIN,
    },
    '& .id-foreground': {
      fill: colors.ID_FOREGROUND,
    },
    '& .id-contrast': {
      fill: colors.ID_CONTRAST,
    },
    '& .component-background': {
      fill: colors.COMPONENT_BACKGROUND,
    },
    '& .component-foreground': {
      fill: colors.COMPONENT_FOREGROUND,
    },
    '& .component-border': {
      stroke: colors.COMPONENT_BORDER,
    },
    '& .component-divider': {
      fill: colors.COMPONENT_BORDER,
    },
    '& .component-foreground-id': {
      fill: colors.COMPONENT_FOREGROUND_ID,
    },
    '& .component-foreground-id-font': {
      fill: fontColor(colors.COMPONENT_FOREGROUND_ID),
    },
    '& .button-foreground': {
      fill: colors.BUTTON_FOREGROUND,
    },
    '& .button-background': {
      fill: colors.BUTTON_BACKGROUND,
    },
    '& .button-focus': {
      stroke: colors.COMPONENT_FOREGROUND_ID,
    },
    '& .button-contrast-focus': {
      stroke: colors.COMPONENT_BACKGROUND,
    },
    '& .social-heart': {
      fill: colors.SOCIAL_HEART,
    },
  };

  return (
    <>
      <PreviewTopBar
        teamName={teamName}
        logoImageUrl={logoImageUrl}
        backgroundColor={topBarOverride ? colors.TOP_BAR_BACKGROUND : colors.ID_MAIN}
        foregroundColor={topBarOverride ? colors.TOP_BAR_FOREGROUND : colors.ID_FOREGROUND}
        borderColor={colors.ID_CONTRAST}
      />
      <Box
        sx={{
          ...styles.container,
          ...{ backgroundColor: darkenColor(colors.ID_MAIN, 0.2) },
        }}
      >
        <Grid2 container sx={previewContainer}>
          <Grid2 sx={styles.column}>
            <Testcard />
            <Tabs />
            <Game />
            <News />
            <Voting />
            <Notifications />
            <Ratingmodal />
            <Loginmodal />
            <Clubselect />
            <Matchform />
          </Grid2>
          <Grid2 sx={styles.column}>
            <Primarybutton />
            <Contrastbutton />
            <Borderbutton />
            <Standings />
            <Matches />
            <Leadertable />
            <Bottombar />
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default Preview;
